module.exports = __webpack_public_path__ + "img/E-WEB-Goal-12.01343bf0.png";